import { render, staticRenderFns } from "./StatisticIndex.vue?vue&type=template&id=7b8d7140"
import script from "./StatisticIndex.vue?vue&type=script&lang=js"
export * from "./StatisticIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports